export enum BlockModalType {
  WorkerInformation = 'WorkerInformation',
  FillRate = 'FillRate',
  NewWorker = 'NewWorker',
  Feedback = 'Feedback',
  Block = 'Block',
}

export interface BlockModalProps {
  isOpen: boolean
  onNext: (modalType: BlockModalType) => void
  onClose: () => void
}
